module.exports = __webpack_public_path__ + "static/banner-tv-caneta-aplicar-hot-fix-a8ea5597001d77cc07e8427282088168.jpg";